import { validateMap } from "../stageEditor/mapValidate.js";
import type { StoredStage } from "../stageMaker/stageRecord.js";

export function customPlayList(stored: Record<string, StoredStage>): StoredStage[] {
  return Object.values(stored)
    .filter((stage) => stage.status === "published" && validateMap(stage.map).length === 0)
    .sort((a, b) => b.updatedAt - a.updatedAt);
}
